import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		tags: {
			maxHeight: 128,
			overflowY: "auto",
		},
		helperText: {
			paddingLeft: 20,
		},
		button: {
			"&:active": {
				backgroundColor: theme.palette.action.disabledBackground,
				color: theme.palette.text.disabled,
			}
		},
		errorMessage: {
			color: theme.palette.error.main,
			fontWeight: "bold",
		}
	} satisfies Record<string, CSSObject>;
};